import { z } from 'zod';
import { Organization } from 'libs/end-to-end/src/types/organizations/organization';

export const Organizations = z.object({
  organizations: z.array(Organization),
});

export type Organizations = z.infer<typeof Organizations>;
